import { makeStyles } from '@material-ui/styles';
import { colors } from '../../../style/colors';
import { ITheme } from '../../../style/theme';

export const useStyles = makeStyles<ITheme>((theme: ITheme) => ({
  dateLabel: {
    display: 'flex',
    alignItems: 'center',
    color: colors.darkGray,
    fontWeight: 700,
    paddingBottom: 8,
  },
  calendarIcon: {
    paddingRight: 8,
    display: 'flex',
  },
  timeIcon: {
    paddingRight: 8,
    paddingLeft: 16,
    display: 'flex',
  },
  name: {
    textOverflow: 'ellipsize',
    wordBreak: 'break-word',
    WebkitLineClamp: 3,
    WebkitBoxOrient: 'vertical',
    display: '-webkit-box',
    WebkitAlignItems: 'center',
    overflow: 'hidden',
    color: colors.darkestGray,
  },
  label: {
    fontWeight: 'bold',
  },
}));

export default useStyles;
